export default {
    googlePlay: 'https://play.google.com/store/apps/details?id=br.gov.am.manaus.descubra',
    appStore: 'https://apps.apple.com/br/app/descubra-manaus/id1480268575'
};